import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ContributePage, ReviewPage } from './ui/Portal';
import { startAccounts, supabase } from './game/account';
import './styles.css';
import { countVisit } from './game/ping';
import { useGame } from './game/store';
import { audio } from './audio/engine';

// Apply the settings this device remembered.
const prefs = useGame.getState();
audio.setSound(prefs.soundOn);
audio.setAtmosphere(prefs.atmosphere);

startAccounts();
// The contributor portal and the owner's review page are plain pages beside the game.
const path = location.pathname.replace(/\/+$/, '');
const Page = path === '/contribute' ? ContributePage : path === '/review' ? ReviewPage : App;
if (Page !== App) document.body.classList.add('portal-page');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Page />
  </StrictMode>,
);

// Installable as an app (PWA); offline modes keep working after the first visit.
if (import.meta.env.PROD) countVisit();
// Development only: lets the browser console audition sounds (__qoobd.audio.playDread('bell')).
if (import.meta.env.DEV) (window as unknown as { __qoobd: unknown }).__qoobd = { audio, useGame, supabase };

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {
      /* installability is a bonus; the game works without it */
    });
  });
}
